import {AfterContentInit, ContentChildren, Directive, Input, QueryList} from '@angular/core';
import {CheckboxTable} from '../../tools/checkbox-table/checkbox-table';
import {CheckboxTableComponent} from '../../components/layout/checkbox-table/checkbox-table.component';
import {CheckboxAllTableComponent} from '../../components/layout/checkbox-all-table/checkbox-all-table.component';

@Directive({
  selector: '[checkboxTable]',
  standalone: true
})
export class CheckboxTableDirective implements AfterContentInit {
  @Input() checkboxTable: CheckboxTable | null = null;
  @ContentChildren(CheckboxTableComponent, {descendants: true}) checkboxTables!: QueryList<CheckboxTableComponent>;
  @ContentChildren(CheckboxAllTableComponent, {descendants: true}) checkboxAllTables!: QueryList<CheckboxAllTableComponent>;

  ngAfterContentInit() {
    this.updateCheckboxTable();
    this.updateCheckboxAllTable();

    this.checkboxAllTables.changes.subscribe(() => {
      this.updateCheckboxAllTable();
    });

    this.checkboxTables.changes.subscribe(() => {
      this.updateCheckboxTable();
    });
  }

  private updateCheckboxTable(): void {
    this.checkboxTable?.clearCheckboxTable();
    this.checkboxTables.forEach((checkboxTableComponent: CheckboxTableComponent) => {
      checkboxTableComponent.setCheckboxTable(this.checkboxTable);
    });
  }

  private updateCheckboxAllTable(): void {
    this.checkboxTable?.clearCheckboxAllTable();
    this.checkboxAllTables.forEach((checkboxAllTableComponent: CheckboxAllTableComponent) => {
      checkboxAllTableComponent.setCheckboxTable(this.checkboxTable);
    });
  }
}
